<template>
  <div id="indexTwo">
    <div class="waring-head" @click="hqGo">
      <a href="javascript:void(0)">提现到活期宝可享3%-6%收益 ></a>
    </div>
    <!-- 转入活期宝 begin -->
    <div class="content-main">
      <div class="main-title">
        <div class="main-title-desc">可转入浪票</div>
        <div class="main-title-set" @click="setting">设置</div>
      </div>
      <div class="able-lang-piao">
        <div class="can-transfer">
          {{hq.live.availableluckymoney}}
        </div>
        <div class="can-transfer-btn-cont">
          <div class="btn-comm" @click="overTo(hq.live.availablecash, hq.live.rate)">转入活期宝</div>
        </div>
      </div>
      <div class="can-price">({{hq.live.availablecash}}元)</div>
      <div class="tx-content">
        <div class="sui-money">
          <div class="sui-money-jiao sui-money-jiao-right">
            <div class="sui-money-desc">待结算浪票</div>
            <div class="sui-money-comm"><span class="sui-money-p">{{hq.live.frozenluckymoney}}</span><span></span></div>
          </div>
          <div class="sui-money-jiao">
            <div class="sui-money-desc">当前持有浪票</div>
            <div class="sui-money-comm"><span class="sui-money-p">{{hq.live.availableluckymoney+hq.live.frozenluckymoney}}</span><span></span>
            </div>
          </div>
        </div>
        <div class="btn-main">
          <div @click="spray()" class="langhua-jl tx-btn-comm">浪票收支记录</div>
          <img class="icon-help" src="../../assets/images/icon_help.png">
          <div class="langhua-hqb tx-btn-comm"><a href="http://lvbsns.eastmoney.com/LVBPages/Static/DiamondsHelp.html">结算浪票帮助</a>
          </div>
        </div>
      </div>
    </div>
    <!-- 转入活期宝 end   -->
    <!-- 提现到银行卡 begin -->

    <div class="content-main hqpord" v-if="isShowHasfundaccount">
      <div class="main-title">
        <div class="main-title-desc">活期宝余额 (元)</div>
      </div>
      <div class="able-lang-piao">
        <div class="can-transfer hqp-price">
          {{ Number(hq.gridData.balance*100 + hq.gridData.notconfirminamount*100 + hq.gridData.notconfirmoutamount*100)/100 | rounding}}
        </div>
        <div class="can-transfer-btn-cont">
          <div class="btn-comm hqp-btn-bank" @click="cash">提现到银行卡</div>
        </div>
      </div>
      <div class="can-price">[ 转入确认中: {{hq.gridData.notconfirminamount}}元 | 提现确认中: {{hq.gridData.notconfirmoutamount}}元
        ]
      </div>
      <div class="tx-content">
        <div class="sui-money">
          <div class="sui-money-jiao sui-money-jiao-right">
            <div class="sui-money-desc">昨日收益 (元)</div>
            <div class="sui-money-comm"><span
              class="sui-money-p">{{hq.gridData.yestdayincome | rounding}}</span><span></span>
            </div>
          </div>
          <div class="sui-money-jiao">
            <div class="sui-money-desc">累计收益</div>
            <div class="sui-money-comm"><span class="sui-money-p">{{hq.gridData.totalincome | rounding}}</span><span></span>
            </div>
          </div>
        </div>
        <div class="btn-main">
          <div class="langhua-jl tx-btn-comm">
            <router-link :to="{ path: '/profit/hqrecord'}">活期宝收支记录</router-link>
          </div>
          <img class="icon-help" src="../../assets/images/icon_help.png">
          <div class="langhua-hqb tx-btn-comm"><a href="#/tips/question" class="jie-comm">关于活期宝的问题</a></div>
        </div>
      </div>
    </div>
    <div class="content-main hqpord hq-tx-cont" v-if="hq.hasfundaccount === true && isJb" @click="showCash($event)">
      <div class="hq-tx-main">
        <div class="hq-tx-desc">我的活期宝(这里提现)</div>
        <div class="right-main">
          <!--<span class="hq-tx-pri">{{ Number(hq.gridData.balance*100 + hq.gridData.notconfirminamount*100 + hq.gridData.notconfirmoutamount*100)/100 | rounding}}元</span>-->
          <span class="hq-tx-pri">{{ hq.gridData.internaltotalamount }}元</span>
          <i class="mui-icon mui-icon-arrowright right-icon"></i>
        </div>
      </div>
    </div>
    <div class="content-main hqpord hq-tx-cont" @click="openRed">
      <div class="hq-tx-main">
        <div class="hq-tx-desc">我的红包<span v-if="redCount > 0">(<span class="h-bao-tip">待领取</span>)</span></div>
        <div class="right-main">
          <span class="hq-tx-pri">{{redCount}}元</span>
          <i class="mui-icon mui-icon-arrowright right-icon"></i>
        </div>
      </div>
    </div>
    <!-- 提现到银行卡 end -->
    <div class="footer">
      <div class="footer-help">
        <div class="btn-main-h">
          <a v-if="isIos" href="tel:021-24099034" class="txt-comm tell" @click='sendMobile'>客服电话: 021-24099034</a>
          <a v-if="!isIos && androidDisplay" href="tel:021-24099034" class="txt-comm tell" @click='sendMobile'>客服电话: 021-24099034</a>
          <a v-if="!isIos && !androidDisplay" href="javascript:void(0)" class="txt-comm">客服电话: 021-24099034</a>
        </div>
        <div class="word-day">工作日：9:00--18:00</div>
      </div>
    </div>
  </div>
  </div>
</template>
<style lang="less" scoped src="../../assets/less/hqpordindex.less"></style>
<script>
  import {mapGetters} from 'vuex'
  import {SET_TITLE} from '../../utils/emapp'
  import {IS_IOS} from '../../utils/useragent'
  import {session} from '../../utils/storage'
  import cookie from '../../utils/cookie'
  export default {
    computed: mapGetters({
      hq: 'initHqpordIndex'
    }),
    data () {
      return {
        isIos: true,
        androidDisplay: false,
        redCount: 0,     // 判断红包
        isShowHasfundaccount: false,
        isJb: true
      }
    },
    mounted: function () {
      session.removeItem('withdrawcard')
      this.isIos = IS_IOS
      if (cookie('version') > '1.4.0') {
        this.androidDisplay = true
      }
      console.log(this.androidDisplay)
      this.$store.dispatch('getLiveAccounts', {_this: this})
      // 获取红包信息
      this.$store.dispatch('getRedInfor', {_this: this})
    },
    methods: {
      // 查看活期宝余额
      look (isShow, event) {
        this.$store.dispatch('changeLook', {isShow: isShow, event: event})
      },
      // 转入活期宝
      overTo (total, rate) {
        if (this.hq.live.authuser === 1 || this.hq.live.authuser === 2 || this.hq.live.authuser === 3) { // 判断实名
          if (this.hq.hasfundaccount) { // 已经绑卡
            this.$router.push({path: '/hqpord/into'})
            /* if (this.hq.live.isidcaradimg === 1) { // 已经传身份证
             this.$router.push({path: '/hqpord/into'})
             } else { // 上传身份证
             let returl = encodeURIComponent(window.location.origin + window.location.pathname + '#/hqpord/index')
             window.location.href = this.hq.live.backurl + `?back_url=${returl}`
             } */
            /* if (this.hq.live.availableluckymoney >= 800) { // 未达到800， 无需传身份证照片
             if (this.hq.live.isidcaradimg === 1) { // 已经传身份证
             this.$router.push({path: '/hqpord/into'})
             } else { // 上传身份证
             let returl = encodeURIComponent(window.location.origin + window.location.pathname + '#/hqpord/index')
             window.location.href = this.hq.live.backurl + `?back_url=${returl}`
             }
             } else {
             this.$router.push({path: '/hqpord/into'})
             } */
          } else { // 未绑卡
            var retUrl = encodeURIComponent(decodeURIComponent(window.location.href))
            this.$router.push({path: '/card/bind', query: {authuser: this.hq.live.authuser, backurl: retUrl}})
          }
        } else { // 未实名认证
          var retUrlE = encodeURIComponent(decodeURIComponent(window.location.href))
          this.$router.push({path: '/card/bind', query: {authuser: this.hq.live.authuser, backurl: retUrlE}})
        }
      },
      // 浪花收支记录
      spray () {
        this.$router.push({path: '/profit/list'})
      },
      showCash (event) {
        /* console.log(event)
         this.isJb = false
         this.isShowHasfundaccount = true */
        this.$router.push({path: '/hqpord/tcash'})
      },
      // 提现
      cash () {
        this.$router.push({path: '/action/index'})
      },
      hqGo () {
        this.$router.push({path: '/tips/upgrade'})
      },
      // 打电话
      sendMobile (event) {
        let time = 5
        let count = setInterval(function () {
          if (time > 1) {
            time--
            $('.tell').attr('href', 'javascript:void(0)')
            console.log(this.telphone)
          } else {
            time = 3
            $('.tell').attr('href', 'tel:021-24099034')
            clearInterval(count)
          }
        }, 1000)
      },
      // 设置
      setting () {
        this.$router.push({path: '/hqpord/setting', query: {'limitAmount': this.hq.live.limitAmount}})
      },
      // 我的红包
      openRed () {
        this.$router.push({path: '/packet/red', query: {availableluckymoney: this.hq.live.availableluckymoney, isidcaradimg: this.hq.live.isidcaradimg, returl: this.hq.live.backurl}})
        /* if (this.hq.hasfundaccount) { // 已经绑卡
         this.$router.push({path: '/packet/red', query: {availableluckymoney: this.hq.live.availableluckymoney, isidcaradimg: this.hq.live.isidcaradimg, returl: this.hq.live.backurl}})
         } else { // 未绑卡
         this.$router.push({path: '/card/bind', query: {authuser: this.hq.live.authuser}})
         } */
      }
    },
    filters: {
      // 截取余额小数点
      rounding: function (value) {
        if (!isNaN(value)) {
          let str = value.toString()
          let sum = str.split('.').length
          if (sum > 1) {
            if (str.split('.')[1].length > 1) {
              return value.toFixed(2)
            }
            return `${value}0`
          }
          return `${value}.00`
        }
      }
    },
    beforeRouteEnter (to, from, next) {
      SET_TITLE('我的收益')
      next()
    }
  }
</script>



// WEBPACK FOOTER //
// original.vue?c78c5d12